import React from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Navbar,NavbarBrand, Table, Form, FormGroup, Col, Input, Button, Container, Spinner, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { Nav, NavItem, NavLink, TabContent,TabPane, Modal, ModalHeader, ModalBody,Collapse,InputGroup, InputGroupAddon } from 'reactstrap';
import Buscador from '../Buscador';
import { async } from 'q';

export default class ConsultaEmpleado extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cargando:false,
            popoverProvOpen:false,
            Temporada:this.props.temp,
            okCon:false,
            tipo:'P',
            per:0,
            ded:0,
            empresa:1,
            emp:0,
            nomEmp:'',
            concepto:0,
            nomCon:'',
            empleado:{},
            empresas:[],
            nomina:[]
        };
        this.cargarCatalogos();
    }
    cargarCatalogos = async () => {
        this.setState({cargando:true});
        let url = `${this.props.urlws}/empresa/empresas`;
        let resp = await fetch(url);
        const empresas = await resp.json();
        this.setState({cargando:false, empresas});
    }
    cargarNomina = async () => {
        this.setState({cargando:true});
        let url = `${this.props.urlws}/nomina/cargarNomCalcEmp?empresa=${this.state.empresa}&empleado=${this.state.emp}`;
        let resp = await fetch(url);
        let per = 0
        let ded = 0
        const nomina = await resp.json();
        for (let i = 0; i < nomina.length; i++) {
            if(nomina[i].T === 'P')
                per += nomina[i].Importe;
            if(nomina[i].T === 'D')
                ded += nomina[i].Importe;
        }
        this.setState({cargando:false, nomina, per, ded});
    }
    cargarEmpleado = async (idEmp) => {
        this.setState({cargando:true});
        let url = `${this.props.urlws}/nomina/cargarEmpleado/${this.state.emp}?empresa=${this.state.empresa}`;
        let resp = await fetch(url);
        const empleado = await resp.json();
        const nomEmp = empleado.Nombre + ' ' + empleado.ApePat + ' ' + empleado.ApeMat;
        this.setState({cargando:false, empleado, nomEmp},()=>{
            this.cargarNomina();
        });
    }
    onChange = (e) => {
        const campo = e.target.name;
        const valor = e.target.value;
        this.setState({ [campo] : valor},() =>{
            //if(campo === "Temporada")
            //   this.cargarLotes();
        });
    }
    toggleEmp = () => {
        this.setState({popoverProvOpen: !this.state.popoverProvOpen});
    }    
    handleClose = () =>{
        this.setState({mostrarModal:false});
    }
    empSel = (item) =>{
        this.setState({popoverProvOpen:false, emp: item.I, nomEmp:item.N},() =>{
            this.cargarEmpleado(item.I);
        });
    }
    onKeyPressEmp = (e) =>{
        if(e.which == 13)
           this.cargarEmpleado(this.state.emp);
    }
    cancelar = () =>{
        this.setState({nomina:[],emp:0, nomEmp:''});
        document.getElementById("emp").focus();
    }    
    render(){
        const estilo1 = { display: this.state.editando ? 'inline' : 'none' };
        const estilo2 = { padding:2, display: this.state.editando ? 'none' : 'inline' };
        const {per} = this.state;
        const {ded} = this.state;
        const tot = per - ded;
        return(
            <Container>
                {this.state.cargando ?
                    <div className="loader">
                        <Spinner animation="border" color="primary" />
                    </div>
                    :
                    null
                }
                <div style={estilo2}>
                    <div className="row">
                        <div className="col-3">
                            <FormGroup>
                                <span>Empresa</span><br />
                                <Input size="sm" type="select" name="empresa" value={this.state.empresa} onChange={this.onChange} style={{ fontSize: '12px' }}>
                                    <option key="0" value="">Especifique</option>
                                    {this.state.empresas.map((i, k) =>
                                        <option key={i.I} value={i.I}>{i.N}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </div>
                        <div className="col-2">
                            <span>Empleado </span><br />
                            <InputGroup>
                                <Input size="sm" type="text" name="emp" value={this.state.emp} onChange={this.onChange} onKeyPress={this.onKeyPressEmp} id="emp" autoFocus />
                                <InputGroupAddon addonType="append">
                                    <Button size="sm" color="success" id="btnBuscarEmp">
                                        <img src="/imagenes/zoom.png" alt="buscar" title="buscar" />
                                    </Button>
                                    <Popover trigger="legacy" placement="right" isOpen={this.state.popoverProvOpen} target="btnBuscarEmp" toggle={this.toggleEmp} >
                                        <PopoverBody>
                                            <Buscador onSelect={this.empSel} url={this.props.urlws + "/nomina/empleadosLista?empresa=" + this.state.empresa + "&filtro="} />
                                        </PopoverBody>
                                    </Popover>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                        <div className="col">
                            <FormGroup>
                                <span>Nombre</span><br />
                                <Input size="sm" type="text" name="nomEmp" value={this.state.nomEmp} readOnly />
                            </FormGroup>
                        </div>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-1">
                                <Button size="sm" color="success" onClick={this.cancelar}>Aceptar</Button>
                            </div>
                            <div className="col-9">
                            </div>
                        </div>
                        <div style={{height:4}}></div>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th style={{ width: 30 }}>Id</th>
                                    <th>Nombre</th>
                                    <th className="numero" style={{ width: 100 }}>Unidades</th>
                                    <th className="numero" style={{ width: 100 }}>Percepciones</th>
                                    <th className="numero" style={{ width: 100 }}>Deducciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.nomina.map((o, i) => (
                                    <tr>
                                        <td className="numero" style={{ width: 30 }}>{o.Id}</td>
                                        <td>{o.N}</td>
                                        {o.T === "U" ?
                                        <td className="numero">{o.Importe.formato()}</td>:
                                        <td></td>
                                        }                                        
                                        {o.T === "P" ?
                                        <td className="numero">{o.Importe.formato()}</td>:
                                        <td></td>
                                        }                                        
                                        {o.T === "D" ?
                                        <td className="numero">{o.Importe.formato()}</td>:
                                        <td></td>
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <Table striped bordered hover size="sm">
                            <tbody>
                                <tr>
                                    <td style={{ width: 30 }}></td>
                                    <td className="rojo">TOTALES</td>
                                    <td style={{ width: 100 }}></td>
                                    <td style={{ width: 100 }} className="numero negro">{per.formato()}</td>
                                    <td style={{ width: 100 }} className="numero rojo">{ded.formato()}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="rojo">TOTAL A PAGAR</td>
                                    <td></td>
                                    <td className="numero negro">{tot.formato()}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Container>
        )
    }
}
class Captura extends React.Component{
    render(){
        return (
            <div></div>
        )
    }
}